// extracted by mini-css-extract-plugin
module.exports = {"Layer":"📚4-7-036IrA","DialogLayer":"📚4-7-03_Y92","Translucent":"📚4-7-01kQNC","disableScroll":"📚4-7-0kQmX9"};